module.exports = __webpack_public_path__ + "static/media/arrow_s_up.4fa350ab.svg";